export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7886.b67432b8.jpg";